// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import get from 'lodash/get'
import filter from 'lodash/filter'
import { i18n } from '../../index'
import { Query } from 'react-apollo'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Loader from '../../../common/loader/Loader'
import withActiveStation from '../../station/withActiveStation'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Paper from '@mui/material/Paper'
import VitrineProductTable from './VitrineProductTable'
import VitrineProductDialog from './VitrineProductDialog'
import { availableVitrineProductsQuery } from './vitrineProductQueries'
import type { VitrineProduct } from './vitrineProductTypes'
import type { Station } from '../../station/stationTypes'
import css from './vitrineProductProducts.css'
type Props = {
  activeStation: Station
}
type State = {
  isDialogOpen: boolean
  data: VitrineProduct | null | undefined
  tab: string
}

@withActiveStation
class VitrineProductProducts extends React.PureComponent<Props, State> {
  state = {
    isDialogOpen: false,
    data: null,
    tab: 'Salty',
  }
  openDialog = () => {
    this.setState({
      isDialogOpen: true,
    })
  }
  closeDialog = () => {
    this.setState({
      isDialogOpen: false,
      data: null,
    })
  }
  onEdit = (data: VitrineProduct) => {
    this.setState({
      data,
    })
    this.openDialog()
  }

  render() {
    const { activeStation } = this.props
    const { isDialogOpen, data, tab } = this.state
    return (
      <div className={css.component}>
        <div className={css.top}>
          <Typography variant='h6'>{i18n.t('admin.vitrineProducts.products.pageTitle')}</Typography>
        </div>
        <Query
          query={availableVitrineProductsQuery}
          variables={{
            stationId: activeStation.id,
          }}
        >
          {({ loading, error, data }) => (
            <Loader
              {...{
                loading,
                error,
              }}
            >
              <Paper>
                <Tabs
                  className={css.tabs}
                  indicatorColor='primary'
                  textColor='primary'
                  value={tab}
                  onChange={(e, value) =>
                    this.setState({
                      tab: value,
                    })
                  }
                >
                  <Tab
                    disableRipple
                    value='Salty'
                    label={i18n.t('admin.vitrineProducts.products.title.saltyProducts')}
                  />
                  <Tab
                    disableRipple
                    value='Sweet'
                    label={i18n.t('admin.vitrineProducts.products.title.sweetProducts')}
                  />
                </Tabs>
                <VitrineProductTable
                  data={filter(get(data, 'availableVitrineProducts', []), {
                    type: tab,
                  })}
                  onEdit={this.onEdit}
                />
              </Paper>
            </Loader>
          )}
        </Query>
        <div className={css.bottom}>
          <Button onClick={this.openDialog} variant='contained' color='primary'>
            {i18n.t('buttons.create')}
          </Button>
        </div>
        <VitrineProductDialog data={data} isOpen={isDialogOpen} onClose={this.closeDialog} />
      </div>
    )
  }
}

export default VitrineProductProducts
